import { render, staticRenderFns } from "./FilterContactShopNameField.vue?vue&type=template&id=7953d8d9&scoped=true"
import script from "./FilterContactShopNameField.vue?vue&type=script&lang=ts"
export * from "./FilterContactShopNameField.vue?vue&type=script&lang=ts"
import style0 from "./FilterContactShopNameField.vue?vue&type=style&index=0&id=7953d8d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7953d8d9",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/search/filter.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Ffilter%2Fform%2FFilterContactShopNameField.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports